export default "__VITE_ASSET__BnzhRUHi__"